<template>
  <div>
    <b-row>
      <!--WEB SERVICE-->
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="host" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.host')" :placeholderValue="$t('common.routing.host')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="port" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="uri" :disabled="readonly" :maxLength="512"
          :inputLabel="$t('common.routing.uri')" :placeholderValue="$t('common.routing.uri')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <label>
          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="sslActive" :disabled="readonly">
          <option value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0" selected> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
    </b-row>
    <!--<level-control-form v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementWebService"></level-control-form>
    <certificate-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="certificateConfig" :placementCertificate="placementWebService"></certificate-form-global>
    <private-keys-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="privateKeysConfig" :placementPrivateKey="placementWebService"></private-keys-form-global>-->
  </div>
</template>
<script>

import CertificateFormGlobal from '@/pages/routing/global/CertificateFormGlobal.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import PrivateKeysFormGlobal from '@/pages/routing/global/PrivateKeysFormGlobal.vue'

export default {
  name: 'WebServiceConfigurationForm',
  components: {
    'certificate-form-global': CertificateFormGlobal,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'level-control-form' : LevelControlForm,
    'private-keys-form-global': PrivateKeysFormGlobal
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    prefilledURI: {
      type: String,
      default: ''
    },
    placementWebService: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name: {
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          name: val,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    host: {
      get () {
        return this.inputValue.host
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: val,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    port: {
      get () {
        return this.inputValue.port
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: val,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    uri: {
      get () {
        return this.inputValue.uri
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: val,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    sslActive: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.sslActive
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: val,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    controlConfig:{
      get () {
        return this.inputValue.controlConfig
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: val,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    certificateConfig:{
      get () {
        return this.inputValue.certificateConfig
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: val,
          privateKeysConfig: this.inputValue.privateKeysConfig
        }
      }
    },
    privateKeysConfig:{
      get () {
        return this.inputValue.privateKeysConfig
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: val
        }
      }
    }
  },
  data () {
    return {
    }
  },
  created () {
    if (this.mode === 'create') {
      if (this.prefilledURI !== undefined || this.prefilledURI === '') {
        this.inputValue.uri = this.prefilledURI
      }
      this.inputValue.sslActive = "0"
    }
  },
  methods: {
  }
}

</script>
